import useServices from '@/legacy-src/hooks/useServices'

import { useGetTherapistLocations } from './useGetTherapistLocations'

export const useSelectedServiceLocations = () => {
  const { selectedServiceId } = useServices()

  const { data, isLoading } = useGetTherapistLocations(selectedServiceId)

  return {
    data: data ?? [],
    isLoading,
  }
}
